import { SVGProps } from 'react';

const Turtle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m8 10-2 4v3a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-3a8 8 0 0 1 16 0v3a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-3l-2-4m0 0H8m4 0 3.18-2.1M2 14h18a2 2 0 0 0 0-4h-3.07M8 10 4.82 7.9"
    />
  </svg>
);
export default Turtle;
